<template>
  <div>
    <form-section-store v-show="isGroupVisible" :path="path" />
    <collapse v-show="isGroupVisible">
      <div class="panel-group" v-show="isGroupExpanded">
        <div v-for="(_, rowIndex) in group.rows" :key="`${group.id}-${rowIndex}`">
          <form-group-row :path="`${path}/${rowIndex}`" :group-read-only="groupReadOnly" />
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import FormSectionStore from './store-controls/FormSectionStore'
import Collapse from '../Collapse.vue'
import FormGroupRow from './FormGroupRow.vue'
import { get, flatten } from 'lodash'

export default {
  name: 'FormGroupStore',
  components: {
    FormSectionStore,
    Collapse,
    FormGroupRow,
  },
  props: {
    path: {
      type: String,
    },
    pageReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    group() {
      return this.$get('groupByPath')(this.path)
    },
    rows() {
      return get(this.group, 'rows', [])
    },
    isGroupExpanded() {
      return !get(this.group, 'collapsed', false)
    },
    hasVisibleFields() {
      return flatten(this.rows).some((field) => !get(field, 'hidden', false))
    },
    isGroupVisible() {
      return !get(this.group, 'hidden', false) && this.hasVisibleFields
    },
    groupReadOnly() {
      return !!(this.pageReadOnly || get(this, 'group.readOnly', false))
    },
  },
}
</script>

<style scoped>
.panel-group {
  margin-top: 15px;
}
</style>
